
export const sourceIcon = [
    {
        image: {
            name: 'Ai GROW Lite',
            url: '/static/default_icon/Ai-GROW-Lite.png',
        },
    },
    {
        image: {
            name: 'ATR CALL BRIX',
            url: '/static/default_icon/ATRCALLBRIX.png',
        },
    },
    {
        image: {
            name: 'LEAF（BookRoll）',
            url: '/static/default_icon/BookRoll_logo.png',
        },
    },
    {
        image: {
            name: 'bsd for School',
            url: '/static/default_icon/bsdforSchool.png',
        },
    },
    {
        image: {
            name: 'デジタルスクールノート',
            url: '/static/default_icon/DigitalShoolNote.jpg',
        },
    },
    {
        image: {
            name: 'ドリルタイム',
            url: '/static/default_icon/DrillTime.png',
        },
    },
    {
        image: {
            name: 'EduMall',
            url: '/static/default_icon/EduMall.png',
        },
    },
    {
        image: {
            name: 'LEAF（ログパレ）',
            url: '/static/default_icon/LogPalette.png',
        },
    },
    {
        image: {
            name: 'RealCAST',
            url: '/static/default_icon/RealCAST.png',
        },
    },
];